import _ from 'lodash';
import $ from 'jquery';
import Tooltip from 'gears/ui/tooltip/component';

// Public Class Methods

class Popover extends Tooltip {

  _render() {
    let adjustedPlacement = this._adjustedPlacement(this.options.placement);
    if (!this.$el) {
      this.$el = $(`\
<div class="${Popover.className} ${Popover.className}--${adjustedPlacement}"></div>\
`)
        .append($(`<div class=${Popover.className}__title></div>`).html(this.options.title))
        .append($(`<div class=${Popover.className}__body></div>`).html(this.options.body));
    } else {
      if (this.changedOptions.title) {
        this.$el.find(`.${Popover.className}__title`).html(this.options.title);
      }
      if (this.changedOptions.body) {
        this.$el.find(`.${Popover.className}__body`).html(this.options.body);
      }
      if (this.changedOptions.placement) {
        this.$el
          .removeClass(`${Popover.className}--${this.previousOptions.placement}`)
          .addClass(`${Popover.className}--${adjustedPlacement}`);
      }
    }

    // only set the max-width style if it's explicitely set
    if (this.options.maxWidth) { this.$el.css("max-width", this.options.maxWidth); }

    // only call position is this popover is currently shown
    if (this._state !== "hidden") { return this._position(); }
  }

  _hideArrow() {
    return this.$el.addClass(`${Popover.className}--no-arrow`);
  }
}


Popover.defaults = {
  animate: true,
  // body: (required)
  destroyOnHidden: false,
  // maxWidth: 300 (set via CSS)
  placement: "top",
  removeOnHidden: true,
  // title: (required)
  trigger: "hover"
};


Popover.className = "popover";

Popover.namespace = "gears:popover";

export default Popover;
